import Vue from 'vue'
import Vuex from 'vuex'
import service from '../../services/gestionTiempos/singNovelty'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    service: new service(),
    date: null,
    novelty: [],
    firmNovelty: {},
    notFirm: {}

  },
  mutations: {

    setDate(state, data) {
      state.date = data
    },
    setFirmNovelty(state, data) {
      state.firmNovelty = data

    },
    setNotFirm(state, data) {
      state.notFirm = data
    }

  },
  actions: {


    async firmNovelty(state) {
      return new Promise(async (resolve, reject) => {
        try {

          await state.state.service.new(state.state.firmNovelty)
          let items = state.state.firmNovelty
          state.commit('setFirmNovelty', items)
          resolve(true)
        }
        catch (error) {
          reject(error)
        }
      })

    },
    async notFirmNovelty(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.notFirmNovelty(state.state.notFirm).then(() => {
            let items = state.state.notFirm

            state.commit('setNotFirm', items)
            resolve(true)

          })


        }
        catch (error) {
          reject(error)
        }
      })

    },



  },



})